import { css } from '@emotion/css';
import { Display, JustifyContent } from 'src/styles';

export const card = css`
  ${JustifyContent.center}
  border: none;
  -webkit-box-shadow: 0rem 0.25rem 1rem rgb(2 85 163 / 15%);
  box-shadow: 0rem 0.25rem 1rem rgb(2 85 163 / 15%);
  margin: auto;
  ${Display.table}
  margin: 0 auto;
  border-radius: 1rem;

  @media (max-width: 489px) {
    display: undefined;
  }
`;
